// removed by extract-text-webpack-plugin
module.exports = {"NewTabModal":"newTabForm__NewTabModal__LNTpo","ErrorMessage":"newTabForm__ErrorMessage__3MD-R","RadioGroup":"newTabForm__RadioGroup__1svo6"};


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Create/newTabForm.css
// module id = 1283
// module chunks = 2